import { keyframes } from '@emotion/react';
import { Box, OptimizeImage, Tooltip } from '@inflearn/ds-react-next';
import { useState } from 'react';
import { CDN_BASE_PATH } from '../slot-dress-up/itemData';

interface DeveloperNoteButtonProps {
  onClick: () => void;
}

// 둥둥 떠오르는 애니메이션
const floatAnimation = keyframes`
  0%, 100% {
    transform: translateY(0) scale(1);
  }
  50% {
    transform: translateY(-2px) scale(1.02);
  }
`;

export const DeveloperNoteButton = ({ onClick }: DeveloperNoteButtonProps) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Box
      pos="absolute"
      top="36px"
      right="32px"
      w={50}
      h={50}
      css={{
        zIndex: 10,
      }}
    >
      <Tooltip label="개발자의 편지" position="bottom" withArrow>
        <Box
          role="button"
          w={50}
          h={50}
          onClick={onClick}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          css={{
            cursor: 'pointer',
            position: 'relative',
          }}
        >
          <OptimizeImage
            src={`${CDN_BASE_PATH}/btn_letter_default_final.png`}
            alt="letter"
            w={50 * 2}
            width={50}
            height={50}
            css={{
              position: 'absolute',
              top: 0,
              left: 0,
              zIndex: 10,
              opacity: isHovered ? 0 : 1,
              transition: 'opacity 0.2s ease',
              pointerEvents: 'none',
              animation: isHovered ? `${floatAnimation} 0.8s ease-in-out infinite` : 'none',
            }}
          />
          <OptimizeImage
            src={`${CDN_BASE_PATH}/btn_letter_hovered_final.png`}
            alt="letter"
            w={50 * 2}
            width={50}
            height={50}
            css={{
              position: 'absolute',
              top: 0,
              left: 0,
              zIndex: 10,
              opacity: isHovered ? 1 : 0,
              transition: 'opacity 0.2s ease',
              pointerEvents: 'none',
              animation: isHovered ? `${floatAnimation} 0.8s ease-in-out infinite` : 'none',
            }}
          />
        </Box>
      </Tooltip>
    </Box>
  );
};
